// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import { Component, Prop } from "vue-property-decorator";

//Components
import WithRender from "Components/Search/ProjectSearchCard/project-search-card.html";

@WithRender
@Component()

export default class ProjectSearchCard extends Vue {
  @Prop({}) imageUrl: string;
  @Prop({}) title: string;
  @Prop({}) url: string;
  @Prop({}) highlightResults: any;
}
